import axios from "../axios-auth";
import orginal_axios from "axios";

export const checkListService = {
  getCheckList,
  getCheckListExcelExport,
};

function getCheckList(searchParams, page, size, sortBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortBy,
  };

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.branchId) {
    params["branchId"] = searchParams.branchId;
  }
  if (searchParams.departmentId) {
    params["departmentId"] = searchParams.departmentId;
  }
  if (searchParams.machineCheckListDetailIds) {
    params["machineCheckListDetailIds"] = searchParams.machineCheckListDetailIds.join();
  }
  if (searchParams.machineIds) {
    params["machineIds"] = searchParams.machineIds.join();
  }
  if (searchParams.machineTypeIds) {
    params["machineTypeIds"] = searchParams.machineTypeIds.join();
  }
  return axios.get("/auth/check-lists", { params });
}

function getCheckListExcelExport(searchParams) {
  let params = {};

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }
  if (searchParams.branchId) {
    params["branchId"] = searchParams.branchId;
  }
  if (searchParams.departmentId) {
    params["departmentId"] = searchParams.departmentId;
  }
  if (searchParams.machineCheckListDetailIds) {
    params["machineCheckListDetailIds"] = searchParams.machineCheckListDetailIds.join();
  }
  if (searchParams.machineIds) {
    params["machineIds"] = searchParams.machineIds.join();
  }
  if (searchParams.machineTypeIds) {
    params["machineTypeIds"] = searchParams.machineTypeIds.join();
  }
  return orginal_axios({
    method: "GET",
    url: axios.defaults.baseURL + "/auth/export-check-list-excel",
    params,
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "Content-Type":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    },
  }).then(function (response) {
    return {
      blob: new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      }),
      headers: response.headers,
    };
  });
}
